import { getAccountData } from '../apis/rebelmouse.js';
import getStore from '../store/index.js';
import { actions as rmAccountActions } from '../store/state/rmAccountData.js';

export async function preloadAccountData() {
  const store = getStore();

  const state = store.getState();

  if (state.rmAccountData.loading || state.rmAccountData.data != null) {
    return;
  }

  store.dispatch(rmAccountActions.START_LOADING());
  try {
    const accountData = await getAccountData();
    store.dispatch(rmAccountActions.ON_DATA(accountData));
  } catch {
    store.dispatch(rmAccountActions.FINISH_LOADING());
  }
}
